export const DEFAULT_YEARS_AHEAD = 15;
export const DEFAULT_PAST_START_DATE = new Date("1900-01-01");
export const DEFAULT_START_DATE = new Date("2000-01-01");
export const DEFAULT_TIME = "09:00";
export const DEFAULT_TIME_12HR = "09:00 AM";
export const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const HEALTH_PROFILE_URL = "/profile/health-profile";
export const PAGE_SIZE = 10;
export const MAATRA_VIDEO_URL = "https://www.youtube.com/watch?v=ZZdYMDAAkxo";
export const MAATRA_DASHBOARD_VIDEO_URL =
  "https://www.youtube.com/watch?v=4Rkwfrtv4jQ";

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB in bytes
